// extracted by css-extract-rspack-plugin
export default {"wrap":"TextBuildingBlockPreview_wrap__bBXUK","content":"TextBuildingBlockPreview_content__pvT3E"};